import { Button, Icons, Box, Stack } from '@cast/design-system';
import { Search, useSearchContext } from '@cast/shared-search-ui';
import { Cluster } from '@cast/types';

import { getDrawerFilterCount } from '../constants/clustersFilters';
import { useClustersAppliedFilterChips } from '../hooks/useClustersAppliedFilterChips';
import { useClustersFiltersDrawer } from '../hooks/useClustersFiltersDrawer';
import { ClustersAppliedFilterChips } from './filters/ClustersAppliedFilterChips';
import { ClustersFilterSummary } from './filters/ClustersFilterSummary';
import { ClusterStateFilter } from './filters/ClusterStateFilter';
import { toolbarFilterControlSx } from './filters/filterLayout';
import { ProviderFilter } from './filters/ProviderFilter';
import { RegionFilter } from './filters/RegionFilter';

export const ClustersPageFilters = () => {
  const searchCtx = useSearchContext<Cluster>();
  const { openClustersFiltersDrawer } = useClustersFiltersDrawer();
  const { chips, hasAppliedFilters, resultCount, appliedFilterCount } =
    useClustersAppliedFilterChips();
  const drawerFilterCount = getDrawerFilterCount(searchCtx?.values);

  return (
    <Stack gap={12} width="100%" data-testid="clusters-page-filters">
      <Stack
        direction="row"
        alignItems="center"
        gap={8}
        sx={{ flexWrap: 'wrap', minWidth: 0 }}
      >
        <Search
          testId="clusters-search-filter"
          placeholder="Search"
          searchWhileActive
          rootSx={{ flex: '1 1 200px', minWidth: 200 }}
          chipInputProps={{
            showClearButton: false,
            sx: {
              '& .DsChipInput-Chip': {
                display: 'none',
              },
            },
          }}
        />

        <Box sx={toolbarFilterControlSx}>
          <ClusterStateFilter />
        </Box>
        <Box sx={toolbarFilterControlSx}>
          <ProviderFilter />
        </Box>
        <Box sx={toolbarFilterControlSx}>
          <RegionFilter />
        </Box>

        <Box sx={{ flexShrink: 0 }}>
          <Button
            variant="ghost"
            size="md"
            startIcon={<Icons.Funnel size={20} />}
            testId="clusters-filter-button"
            onClick={openClustersFiltersDrawer}
          >
            {drawerFilterCount > 0
              ? `Filters (${drawerFilterCount})`
              : 'Filters'}
          </Button>
        </Box>
      </Stack>

      {hasAppliedFilters ? (
        <>
          <ClustersFilterSummary
            resultCount={resultCount}
            appliedFilterCount={appliedFilterCount}
          />
          <ClustersAppliedFilterChips chips={chips} />
        </>
      ) : null}
    </Stack>
  );
};
